import React from 'react';
import BarChartIcon from "@mui/icons-material/BarChart";
import './VoteStatusButton.css';

const VoteStatusButton = ({ onClick }) => {
  return (
    <button className="voteStatusButtonNew" onClick={onClick}>
      <BarChartIcon />
      <span>Vezi starea voturilor</span>
    </button>
  );
};

export default VoteStatusButton; 